// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".margin-bottom[data-v-7c73dbd3]{margin-bottom:30px}@media (max-width:1919px){.margin-bottom[data-v-7c73dbd3]{margin-bottom:45px}}@media (max-width:1365px){.margin-bottom[data-v-7c73dbd3]{margin-bottom:35px}}@media (max-width:1023px){.margin-bottom[data-v-7c73dbd3]{margin-bottom:55px}}", ""]);
// Exports
module.exports = exports;
